import { useMediaQuery } from 'react-responsive';
import breakpoints from '../assets/styles/variables/breakpoints.module.scss';
const useResponsive = (size) => {
    return useMediaQuery({
        query: `(max-width: ${breakpoints[size]}px)`
    });
};
export default useResponsive;
